export enum SogAlign {
  Start = "start",
  Center = "center",
  End = "end",
  Stretch="stretch"
}
